import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/sections/HeroSection';
import { TrustedBySection } from './components/sections/TrustedBySection';
import { VideoTestimonialsSection } from './components/sections/VideoTestimonialsSection';
import { CoachesSection } from './components/sections/CoachesSection';
import { TechnicalTeamSection } from './components/sections/TechnicalTeamSection';
import { ValueStackSection } from './components/sections/ValueStackSection';
import { TimelineSection } from './components/sections/TimelineSection';
import { CoachingTiersSection } from './components/sections/CoachingTiersSection';
import { AddOnSection } from './components/sections/AddOnSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { CTASection } from './components/sections/CTASection';
import { FAQSection } from './components/sections/FAQSection';
import { LowerTierSection } from './components/sections/LowerTierSection';
import { OnboardingPage } from './components/pages/OnboardingPage';
import { BookingPage } from './components/pages/BookingPage';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// HomePage component to keep all the existing sections together
const HomePage = () => <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24]" data-id="element-0" data-mp="4wylxj0jajy">
    <HeroSection data-id="element-1" data-mp="2zlv8x0aavbxp" />
    
    <VideoTestimonialsSection data-id="element-2" data-mp="2zmo557bmuj1l" />
    <CoachesSection data-id="element-3" data-mp="2zng32ospcsv1" />
    <TechnicalTeamSection data-id="element-4" data-mp="33mf0zpg0npcz" />
    <ValueStackSection data-id="element-5" data-mp="33nq5jrhad155" />
    <TimelineSection data-id="element-6" data-mp="33mymth8sexwa" />
    <AddOnSection data-id="element-7" data-mp="33oi0r16z0wuw" />
    <TestimonialsSection data-id="element-8" data-mp="38m1f013o59mu" />
    <CTASection data-id="element-9" data-mp="38kqbm2e4y3w9" />
    <FAQSection data-id="element-10" data-mp="38k6v8q44vnkc" />
    <TrustedBySection data-id="element-11" data-mp="38nuodo5o27yj" />
  </div>;
export function App() {
  useEffect(() => {
    // Initialize Amplitude after the library loads
    const initializeAmplitude = () => {
      if (typeof window !== 'undefined' && window.amplitude) {
        try {
          window.amplitude.add(window.sessionReplay.plugin({
            sampleRate: 1
          }));
          window.amplitude.init('c6d27b6debb3ed4d9204f7f2b635f009', {
            fetchRemoteConfig: true,
            autocapture: true
          });
        } catch (error) {
          console.warn('Amplitude initialization failed:', error);
        }
      } else {
        // Retry after a short delay if amplitude isn't loaded yet
        setTimeout(initializeAmplitude, 100);
      }
    };
    // Start initialization attempt
    initializeAmplitude();
  }, []);
  return <HelmetProvider data-id="element-12" data-mp="3bn30qacdcwy0">
      <Helmet data-id="element-13" data-mp="3bnutzeihuil4">
        <script src="https://cdn.amplitude.com/script/c6d27b6debb3ed4d9204f7f2b635f009.js" data-id="element-14" data-mp="3bo4isyrsyjp8" />
      </Helmet>
      <Router data-id="element-15" data-mp="3qdajkr6aghz8">
        <Routes data-id="element-16" data-mp="3lkhg06mk3foq">
          <Route path="/" element={<HomePage data-id="element-18" data-mp="3ljfzhmmru0zm" />} data-id="element-17" data-mp="3ljxwilh9cj8l" />
          <Route path="/onboarding" element={<OnboardingPage data-id="element-20" data-mp="2xun2rnybrp3y" />} data-id="element-19" data-mp="3lj6c86t427xm" />
          <Route path="/start" element={<BookingPage data-id="element-22" data-mp="2xt2900ju4a75" />} data-id="element-21" data-mp="2xtv6eawwlncm" />
        </Routes>
      </Router>
    </HelmetProvider>;
}